import { RxHome } from 'react-icons/rx'
import { IoMdHeartEmpty } from 'react-icons/io'
import { MdSlowMotionVideo } from 'react-icons/md'
import { HiOutlineUsers } from 'react-icons/hi'
import { TbEdit } from 'react-icons/tb'

import './nav.css'

const Nav = ({data, isCurrent, isSetCurrent, isSetShow}) => {

      const openPage = (page) => {
            isSetShow(true)
            isSetCurrent(page)
      }

      const closePage = () => {
            isSetShow(false)
            isSetCurrent('home')
      }

      return (
            <div className="navigator">
                  <div className="nav_avatar">
                        <img src={data.avatar} alt={data.name} />
                  </div>
                  <div className="nav_menu">
                        <ul>
                              <li className={isCurrent === 'home' ? "nav_menu__item active" : "nav_menu__item"} onClick={() => closePage()}>
                                    <RxHome />
                                    <span>Home</span>
                              </li>
                              <li className={isCurrent === 'relation' ? "nav_menu__item active" : "nav_menu__item"} onClick={() => openPage('relation')}>
                                    <IoMdHeartEmpty />
                                    <span>Crush</span>
                              </li>
                              <li className={isCurrent === 'video' ? "nav_menu__item active" : "nav_menu__item"} onClick={() => openPage('video')}>
                                    <MdSlowMotionVideo />
                                    <span>Video</span>
                              </li>
                              <li className={isCurrent === 'friend' ? "nav_menu__item active" : "nav_menu__item"} onClick={() => openPage('friend')}>
                                    <HiOutlineUsers />
                                    <span>Friends</span>
                              </li>
                              <li className="nav_menu__item">
                                    <a href="https://xat.com/editme" target="_blank" rel="noreferrer">
                                          <TbEdit />
                                          <span>Edit</span>
                                    </a>
                              </li>
                        </ul>
                  </div>
            </div>
      )
}

export default Nav
